const receipts = (receipts = [], action) => {
  switch (action.type) {
    case 'FETCH_RECEIPTS':
      return action.payload
    default:
      return receipts
  }
}
export default receipts
